/** Chapter helpers. Chapters are stored on the server (messages.is_chapter). */

/** Short chapter title: first non-empty line without markdown quote/heading marks. */
export function chapterTitle(content: string, max = 40): string {
  const line = content.split('\n').map((l) => l.replace(/^[>#\s*-]+/, '').trim()).find(Boolean) ?? '…';
  return line.length > max ? `${line.slice(0, max).trimEnd()}…` : line;
}
